export function getSelectedItems(selectedItems, eventKey, category) {
  const multiSelection = category.multiSelection || false;
  if (multiSelection) {
    return [...selectedItems, eventKey];
  } else {
    const categoryKeys = category.itemOptions.map(option => option.key);
    const newItems = selectedItems.filter(key => !categoryKeys.includes(key));
    return [...newItems, eventKey];
  }
}
function getAllItemOptions(nested) {
  if (nested === undefined) {
    return undefined;
  }
  const itemOptions = nested.flatMap(nest => nest.itemOptions);
  let allOptions = itemOptions;
  itemOptions.forEach(option => {
    if (option.hasOwnProperty('nested')) {
      const nestedK = getAllItemOptions(option.nested) || [];
      allOptions = [...allOptions, ...nestedK];
    }
  });
  return allOptions;
}
export function getAllNestedKeys(nested) {
  if (!nested) {
    return undefined;
  }
  const itemOptions = getAllItemOptions(nested);
  return itemOptions === null || itemOptions === void 0 ? void 0 : itemOptions.flatMap(option => option.key);
}
export function getOptionsDuplicatedKeys(options) {
  const itemOptions = options.flatMap(opt => opt.itemOptions).filter(opt => opt);
  const keys = itemOptions.map(opt => opt.key);
  const nestedKeys = getAllNestedKeys(itemOptions.filter(opt => !!opt.nested).flatMap(opt => opt.nested || [])) || [];
  const sorted_arr = [...keys, ...nestedKeys].sort();
  const results = [];
  for (let i = 0; i < sorted_arr.length - 1; i++) {
    if (sorted_arr[i + 1] === sorted_arr[i]) {
      results.push(sorted_arr[i]);
    }
  }
  return results;
}
//# sourceMappingURL=helpers.js.map